
import { defineComponent } from "vue";

export default defineComponent({
  name: "BaseImage",
  props: {
    title: String,
  },
  data(): {
    images: Array<{ description: string; src: string }>;
    randomImage: { description: string; src: string };
  } {
    return {
      images: [
        { description: "Singapore, Wheelock Place", src: "wheelock.jpg" },
        {
          description: "Sailor's 110th Anniversary Pen, Kurogane",
          src: "kurogane.jpg",
        },
        { description: "Singapore, Hafary Gallery", src: "hafary (1).jpg" },
        { description: "Singapore, Hafary Gallery", src: "hafary (2).jpg" },
        { description: "Singapore, Hafary Gallery", src: "hafary (3).jpg" },
        { description: "Singapore, Hafary Gallery", src: "hafary (4).jpg" },
        { description: "Singapore, Hafary Gallery", src: "hafary (5).jpg" },
        { description: "Singapore, Near Kallang Wave", src: "kallang (1).jpg" },
        { description: "Singapore, Near Kallang Wave", src: "kallang (2).jpg" },
        { description: "Singapore, Near Kallang Wave", src: "kallang (3).jpg" },
        { description: "Singapore, Near Kallang Wave", src: "kallang (4).jpg" },
        { description: "Singapore, Near Kallang Wave", src: "kallang (5).jpg" },
        { description: "Singapore, Changi Jewel", src: "changi.jpg" },
        { description: "Singapore, NTU", src: "ntu.jpg" },
        { description: "Singapore, The Star Vista", src: "star vista.jpg" },
        { description: "My Cat, Mao Mao", src: "cat (1).jpg" },
        { description: "My Cat, Mao Mao", src: "cat (2).jpg" },
      ],
      randomImage: { description: "", src: "" },
    };
  },
  methods: {
    getRandomImage(images: Array<{ description: string; src: string }>): {
      description: string;
      src: string;
    } {
      let t = images[Math.floor(Math.random() * images.length)];
      t.src = require("@/assets/backgrounds/" + t.src);
      return t;
    },
  },
  beforeMount(): void {
    this.randomImage = this.getRandomImage(this.images);
  },
});
